import React, { Fragment, lazy, Suspense } from "react";
import LazyLoader from "../components/masterLayout/LazyLoader";
const NotFound = lazy(() => import("../components/NotFound/NotFound"));
const Page404 = () => {
  return (
    <Fragment>
      <Suspense fallback={<LazyLoader />}>
        <NotFound />
      </Suspense>
    </Fragment>
  );
};

export default Page404;
